import 'whatwg-fetch';

/* Leaflet */

import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-measure';
import 'leaflet.heat';
import 'leaflet.markercluster';
import 'leaflet.gridlayer.googlemutant';
import 'react/lib/leaflet/polyline.js';
import 'react/lib/leaflet/multipolyline.js';
import '@maplibre/maplibre-gl-leaflet';
import { BingProvider } from 'leaflet-geosearch';
import Bowser from 'bowser';

/* End - Leaflet */

import React from 'react';
import { createRoot } from 'react-dom/client';
import Immutable from 'immutable';

import Quill from 'quill';
import Application from 'react/components/GreenmileApplication';

import Dragula from 'dragula';
import actions from 'react/api/actions/index.js';

import Viewer from 'viewerjs';

window.Immutable = Immutable;
window.L = L;
window.BingProvider = BingProvider;
window.Quill = Quill;
window.Bowser = Bowser;
window.Dragula = Dragula;
window.actions = actions;
window.Viewer = Viewer;

createRoot(document.getElementById('root')).render(<Application />);

if (module.hot) {
  module.hot.accept();
}
